import { FILE_ERROR_CODES } from './manageImagesModal.types'

const messages = {
  assignNImages: 'Assign ":amount" Images',
  browseAllImages: 'Browse all images',
  cancel: 'Cancel',
  chooseSingleImage:
    'Choose a single image to the right and press plus on the corresponding color below to assign.',
  colorImages: 'Color Images',
  discardChanges: 'Discard Changes',
  discardChangesQuestion: 'Discard Changes?',
  editSwatches: 'Edit Swatches',
  error: 'Error',
  errorLoadingStyle: 'There was an error trying to load the style data.',
  errorRemovingImagesDesc:
    'We ran into an issue while removing your images, please try again.',
  errorRemovingImagesTitle: 'Error Removing Images',
  errorSavingImages:
    'We ran into an issue while saving your images, please try again.',
  manageImages: 'Manage Images',
  manageYourImages: 'Manage Your Images',
  nextStyle: 'Next Style',
  noResultsFound: 'No results found for ',
  of: 'of',
  previousStyle: 'Previous Style',
  productImages: 'Product Images',
  removingImages: 'Removing images...',
  save: 'Save',
  searchAllImages: 'Search All Images',
  selectLimitReached: 'Maximum number of images per styles reached',
  success: 'Success',
  successSavingImages: 'Style images saved successfully!',
  unsavedChangesContent:
    'You have unsaved changes. Are you sure you want to proceed?',
  uploadError: 'Upload Error',
  uploadNewImages: 'Upload new images',
  uploadUpToNImages: 'Click to upload up to :limit images',
  uploadingImages: 'Uploading images...',
} as const

export const ERROR_DESCRIPTIONS = {
  [FILE_ERROR_CODES.INVALID]: 'File must be a .png or .jpg image.',
  [FILE_ERROR_CODES.TOO_LARGE]: 'File size must be less than 10MB.',
  [FILE_ERROR_CODES.TOO_MANY]: 'You can only upload up to {max} files.',
  UNKNOWN: 'There was an error uploading your image.',
}

export default messages
